import React from "react";
import GenericLayout from "layouts/generic";
import css from "./index.module.scss";
import FloatingImageSection from "sections/floatingImage";
import StripedCtaSection from "sections/stripedCta";
import FloatingImage from "@/components/floatingImage";
import TestimonialsSection from "sections/testimonials";
import ContactSection from "sections/contact";
import BobbingArrow from "@/components/bobbingArrow";
import Wistia from "@/components/wistia";
import Button from "@/components/button";
import Picture from "@/components/picture";
import QuoteLeftSvg from "/public/images/icons/quoteLeft.svg";
import ReactPlayer from "react-player";
import Link from "next/link";

const testimonials = [
  {
    "image": "/images/portraits/manatMcleod/manatMcleod-200w",
    "quote": <>I&apos;ve been working with the Deviate Labs team for over a year now and it has been a fantastic experience! As our project has evolved, the team was able to adapt and optimize for each stage. <span>Deviate Labs is a creative and resourceful team with many facets of expertise — I highly recommend their services.</span></>,
    "author": "Manat MacLeod @ SMART Technologies",
  },
  {
    "image": "/images/portraits/jennyCipoletti/jennyCipoletti-200w",
    "quote": <>Deviate is incredibly thoughtful in their approach to our app&apos;s advertising strategy. <span>They&apos;re a data-driven team that executes at a high level and provides a lot of innovative ideas.</span> We genuinely appreciate their enthusiasm and can-do attitudes!</>,
    "author": "Jenny Cipoletti @ Tivvit",
  },
  {
    "image": "/images/portraits/dustinMartin/dustinMartin-200w",
    "quote": <>Deviate Labs is a cutting-edge, comprehensive, and well-informed marketing company. We have been beyond impressed with their proactive nature and diligence in quickly getting our business working multiple angles that we would have otherwise not had the time for or the knowledge of. <span>By using traditional, tried and true marketing concepts in new and technology-driven ways, they are working on a whole different level than most in their field.</span></>,
    "author": "Dustin Martin @ Martin Studios",
  },
  {
    "image": "/images/portraits/krishnaSurendra/krishnaSurendra-200w",
    "quote": <>We have been working with Deviate Labs since March 2017. It started with an introductory call which lasted for 45 min. <span>I knew that they would be the guys to help us expand our business and get more customers.</span> Deviate Labs has been helping me with content marketing and running Google ads for our product and so far it&apos;s productive.I would recommend Deviate Labs for anyone who wants to expand their business and see a rapid growth.</>,
    "author": "Krishna Surendra @ HR Cloud",
  },
  {
    "image": "/images/portraits/brandonHollier/brandonHollier-200w",
    "quote": <>Business consulting, in todays evolving environment, AT ITS FINEST! Can&apos;t say enough great things about Deviate Labs and their professionals.  Extremely knowledgeable in everything business. <span>Whether it is a small local start up or a national organization, the team at Deviate Labs delivers custom solutions to meet specific needs.</span> Our national company, Brush Baggy, has benefited greatly in the short amount of time we have been working with them, catapulting our reach and crafting many differential advantages that would not have had otherwise!</>,
    "author": "Brandon Hollier @ BrushBaggy",
  },
  {
    "image": "/images/portraits/chadThompson/chadThompson-200w",
    "quote": <>Over the last year I had the pleasure of working with Deviate Labs on a variety of marketing strategies and tactics. They are a knowledgeable, forward thinking, creative team who met the unique needs of Badass Beard Care. We were extremely pleased with their ability to manage multiple projects and deliver quality content under tight deadlines. Their advanced knowledge of traditional and non-traditional marketing tactics ultimately allowed them to create and implement digital marketing strategies that had a impressive impact on <span>influencer marketing, customer acquisition, retention and nurture flow, digital ROAS, email marketing and customer insight.</span></>,
    "author": "Chad Thompson @ Badass Beard Care",
  },
  {
    "image": "/images/portraits/dawnAnderson/dawnAnderson-200w",
    "quote": <>Thank you Deviate Labs! They are wonderful to work with — 100% available, responsive, professional and data driven. Their work is over and above what I expected, <span>always stepping up with new campaigns, suggestions to improve all things in digital marketing</span>, not just in their domain, which as a small team, I appreciate. They have been incredibly helpful in our success. Great work Deviate!</>,
    "author": "Dawn Anderson @ Ohi Food Co",
  },
  {
    "image": "/images/portraits/thomasVanDerKleij/thomasVanDerKleij-200w",
    "quote": <>After having gone through several marketing agencies, Deviate Labs is the first one to truly &apos;get&apos; it. Most marketing agencies we worked with had their formula, which they then tried to apply to our business. Deviate Labs really looked at what was needed for our specific business and then came up with a solid combination of tried and tested channels, as well as more novel approaches. <span>We have been hitting record after record ever since. 10/10 recommend.</span></>,
    "author": "Thomas van der Kleij @ Tapfiliate",
  },
  {
    "image": "/images/portraits/sumanPrakashDas/sumanPrakashDas-200w",
    "quote": <>I have had a fantastic experience with Deviate Labs and Chad. Chad is a fantastic thinker, collaborative, and just a great team member. <span>He and his agency are a fantastic add to the marketing engine of any company.</span></>,
    "author": "Suman Prakash Das @ Radix",
  },
  {
    "image": "/images/portraits/brian-koffler/brian-koffler-square",
    "quote": <>I have been extremely impressed by Deviate Labs&apos; ability to understand how each of my businesses functions on a <span>very deep level.</span></>,
    "author": "Brian Koffler @ Explore + Discover",
  },
  {
    "image": "/images/portraits/paul-howey/paul-howey-square",
    "quote": <>An uncanny ability to come up with <span>insanely creative solutions</span> to the most difficult marketing problems.</>,
    "author": "Paul Howey @ Talkroute",
  },
  {
    "image": "/images/portraits/ashley-harper/ashley-harper-square",
    "quote": <><span>Deviate Labs is easy to work with</span>... they care about how the product they are creating will benefit you.</>,
    "author": "Ashley Harper @ Alexander Marine USA",
  },
];

export default function GrowthMarketingAgencyPage() {
  return <GenericLayout
    title="Cutting-Edge Growth Marketing Agency | Deviate Labs"
    description="Deviate Labs is a growth marketing agency established in 2013 offering a wide spectrum of custom-tailored growth hacking services, both advisory and execution."
    color="purple"
    canonical="/growth-marketing-agency/"
  >
    <section className={`section ${css.fold}`}>
      <div className="sectionInner">
        <div className={css.text}>
          <h1>
            <div>Cutting-Edge</div>
            <div>Growth Marketing</div>
            <div>Agency</div>
          </h1>
          <div className={css.subheadline}>Ready to scale your startup and drive sustainable growth?</div>
          <Button label="Let's Talk" href="#contact" light ghost/>
        </div>
        <div className={css.image}>
          <Picture
            base="/images/misc/pillars/pillars"
            alt=""
            exts={["webp", "png"]}
            widths={[250, 500, 750, 1000]}
            loading="eager"
            sizes="50vw"
          />
        </div>
      </div>
    </section>


    <section className={`section ${css.clients}`}>
      <div className="sectionInner">
        <h2>We&apos;ve helped companies of all different industries and sizes, including:</h2>
        <ul>
          <li>venture-backed startups like <a href="https://us.dollarshaveclub.com/">Dollar Shave Club</a>, acquired by Unilever for $1 billion</li>
          <li>celebrity-founded startups like <a href="https://hellobello.com/">Hello Bello</a>, founded by Kristen Bell and Dax Shepard</li>
          <li>bootstrapped ventures like <a href="https://tapfiliate.com/">Tapfiliate</a>, the largest affiliate marketing SaaS company in Europe</li>
          <li>Shark Tank featured startups like <a href="https://lollaland.com/">Lollaland</a>, backed by Mark Cuban and Robert Herjavec</li>
          <li>Grammy-nominated musicians like <a href="http://www.abadthink.com/">Michael Marquart</a>, former drummer in the 80s rock band, A Flock of Seagulls</li>
        </ul>
      </div>
    </section>


    <section className={`section ${css.testimonialSpotlight}`}>
      <div className="sectionInner">
        <h2>Why Companies Choose Us</h2>
        <div className={css.text}>Deviate Labs marries time-proven marketing tactics with creative &quot;out-of-the-box&quot; growth hacks. Growth marketing isn&apos;t &quot;one size fits all.&quot; Each client&apos;s circumstances are unique. Rather than fit every client into a cookie-cutter plan, we customize our tactics for every engagement.</div>

        <div className={css.testimonialBlock}>
          <div className={css.quote}>
            <QuoteLeftSvg/>
          </div>
          <div className={css.testimonial}>
            <div className={css.highlighted}>After having gone through several marketing agencies, Deviate Labs is the first one to truly &apos;get&apos; it.</div>
            <div className={css.mainQuote}>Most marketing agencies we worked with had their formula, which they then tried to apply to our business. Deviate Labs really looked at what was needed for our specific business and then came up with a solid combination of tried and tested channels, as well as more novel approaches. We have been hitting record after record ever since. 10/10 recommend.</div>
            <hr />
            <div className={css.author}>Thomas van der Kleij</div>
            <div className={css.company}>Tapfiliate</div>
          </div>
        </div>
      </div>
    </section>

    <section className={`section ${css.difference}`}>
      <div className="sectionInner">
        <h2>The Deviate Labs Difference</h2>

        <div className={css.video}>
          <ReactPlayer url="https://deviatelabs.wistia.com/medias/u4d740vkuz"
            light={ <Picture
              base="/images/videos/sizzleReel/sizzleReel"
              exts={["webp", "png"]}
              widths={[500, 1000, 1500, 2000]}
              loading="lazy"
              alt="Video thumbnail"
              sizes="100vw"
            />}
            width="100%"
            height="100%"
            config={
              {
                wistia: {
                  options: {
                    autoPlay: true,
                    playbar: true,
                  },
                },
              }
            }
          />
        </div>

        <div className={css.subheadline}>Our growth marketing experience spans a breadth of industries and products, including:</div>
        <ul>
          <li>The website hosting division of Automattic, the company behind WordPress</li>
          <li>Beasts of Balance, an interactive board game company backed by Amazon and acquired by Niantic, the creators of Pokémon Go</li>
          <li>An international conglomerate that owns the resale rights to all .tech domains</li>
          <li>We are based in North America, but our clients span the US, London, Paris, Amsterdam, Mumbai, Shanghai, and beyond. As marketing ambassadors, we take tactics forged in the fires of America&apos;s free market capitalism and transport them around the world.</li>
        </ul>
        <Link href="/resources/categories/case-studies"><a className={css.link}>Read our growth marketing success stories.</a></Link>
      </div>
    </section>

    <section className={`section ${css.process}`}>

      <div className={`sectionInner ${css.sectionInner}`}>
        <div className={css.text}>
          <h2>
            <div>Our Growth&nbsp;</div>
            <div>Process</div>
          </h2>
          <p>Deviate Labs&apos; growth marketing ideology is rooted in marketing fundamentals compounded with battle-tested innovation. We collaborate with every client to develop a custom strategy and lay out a working roadmap that prioritizes whatever will have the most impact on their goals.</p>
          <p><b>Whether the recipe calls for tried-and-true channels of performance marketing, testing unique growth hacks, or exploring new initiatives altogether — or a blend of all of the above — we&apos;ve done it all.</b></p>
        </div>
        <div className={css.image}>
          <Picture
            base="/images/misc/techyChart/techyChart"
            alt=""
            exts={["webp", "png"]}
            widths={[100, 200, 300, 400, 500, 600, 700, 800, 900, 1000]}
            loading="lazy"
            sizes="50vw"
          />
        </div>
      </div>
    </section>

    <section className={`section ${css.platforms}`}>
      <div className={css.background}>
        <div className={css.circle}></div>
        <div className={css.circle}></div>
        <div className={css.circle}></div>

        <span className={css.logo}>
          <Picture
            base="/images/logos/google/google"
            alt=""
            exts={["webp", "png"]}
            widths={[50, 100, 150, 200, 250]}
            loading="lazy"
            sizes="200px"
          />
        </span>
        <span className={css.logo}>
          <Picture
            base="/images/logos/linkedin/linkedin"
            alt=""
            exts={["webp", "png"]}
            widths={[50, 100, 150, 200, 250]}
            loading="lazy"
            sizes="200px"
          />
        </span>
        <span className={css.logo}>
          <Picture
            base="/images/logos/meta/meta"
            alt=""
            exts={["webp", "png"]}
            widths={[50, 100, 150, 200, 250]}
            loading="lazy"
            sizes="200px"
          />
        </span>
        <span className={css.logo}>
          <Picture
            base="/images/logos/tiktok/tiktok"
            alt=""
            exts={["webp", "png"]}
            widths={[50, 100, 150, 200, 250]}
            loading="lazy"
            sizes="200px"
          />
        </span>
        <span className={css.logo}>
          <Picture
            base="/images/logos/youtube/youtube"
            alt=""
            exts={["webp", "png"]}
            widths={[50, 100, 150, 200, 250]}
            loading="lazy"
            sizes="200px"
          />
        </span>
        <span className={css.logo}>
          <Picture
            base="/images/logos/twitter/twitter"
            alt=""
            exts={["webp", "png"]}
            widths={[50, 100, 150, 200, 250]}
            loading="lazy"
            sizes="200px"
          />
        </span>
      </div>

      <div className={`sectionInner ${css.sectionInner}`}>
        <h2>Why Clients Choose Us</h2>
        <div className={css.text}>We have full marketing stack capability, offering a suite of services to cover the fundamentals of performance marketing. Services include programmatic advertising, influencer marketing, content strategy, email marketing, app store advertising, search optimization, landing page development, go-to-market strategy, and more. We build the engine, complete with the nuts and bolts of marketing analytics configuration, so we can experiment and optimize to drive results.</div>
        <Button label="Our Services" href="/services" light ghost/>
      </div>
    </section>

    <section className={`section ${css.xFactor}`}>
      <div className="sectionInner">
        <div className={css.image}>
          <Picture
            base="/images/misc/xCube/xCube"
            alt=""
            exts={["webp", "png"]}
            widths={[250, 500, 750]}
            loading="lazy"
            sizes="50vw"
          />
        </div>
        <div className={css.text}>
          <h2>The &quot;X&quot; Factor</h2>
          <p>When circumstances align and clients crave certain out-of-the-box tactics, we concoct creative, experimental growth hacks. We start with a brainstorm session to align on campaign goals, brand fit, risk tolerance, and potential outcomes. Then we handle execution from start to finish - handling the mise-en-place and cooking up a Michelin-worthy growth stunt. Following are three examples whose results exceeded even our own expectations, with some confidential details omitted for client privacy.</p>
          <Button label="Contact Us" href="#contact" light ghost/>
        </div>
      </div>
    </section>

    <section className={`section ${css.cta}`}>
      <div className="sectionInner">
        <h2>Ready for Growth?</h2>
        <Button label="Contact Us" href="#contact" light ghost/>
      </div>
    </section>


    <section className={`section ${css.caseStudies}`}>
      <div className="sectionInner">
        <h2>Case Studies</h2>
        <div className={css.subheadline}>Here are some highlights from our favorite growth hacks...</div>
        <div className={css.caseStudy}>
          <div className={css.text}>
            <h3>
              <div>Breaking Through the</div>
              <div>Black Friday Noise</div>
            </h3>

            <p><a href="https://radix.website">Radix</a> owns the registration rights for top-level domains, and they retained us to strategize and execute a campaign to capture the tech community&apos;s attention. Our ultimate goal was to raise awareness around Radix&apos;s .tech domains.</p>

            <p>After a collaborative ideation process, we decided on an &quot;anti-ad campaign.&quot; We scheduled it to launch on the most crowded advertising week of the year: Black Friday through Cyber Monday. To break through the commercial noise, we conceived and architected a series of digital puzzle rooms. Each room was a tech-themed challenge filled with ciphers and trivia tailored to the tech community.</p>

            <p>Over 193,000 techies tried their hand at Break the Code, with the average visitor spending an astonishing 17.4 minutes on the site! Our campaign spawned a plethora of earned media, ranging from YouTube tutorials to a dedicated Discord server, to a 5000+ comment Reddit megathread. There was even a change.org petition for Break the Code themed merchandise. Radix quite literally had people writing in to say that the campaign changed their lives.</p>
            <Button label="Our Services" href="/services" light ghost/>

          </div>
          <div className={css.image}>
            <Picture
              base="/images/misc/breakTheCode/breakTheCode"
              alt=""
              exts={["webp", "png"]}
              widths={[250, 500]}
              loading="lazy"
              sizes="50vw"
            />
          </div>
        </div>
        <div className={css.caseStudy}>

          <div className={css.text}>
            <h3>
              <div>Sold-Out Pre-Launch</div>
              <div>on a $0 Ad Budget</div>
            </h3>


            <p>We were retained by a Chinese pet product manufacturer. They wanted to transition from white-label retail partnerships to direct-to-consumer household sales.</p>

            <p>Inspired by Google&apos;s <a href="https://blog.google/inside-google/company-announcements/for-star-wars-fans-old-and-new/">Star Wars homage</a> and <a href="https://tim.blog/2014/07/21/harrys-prelaunchr-email/">infamous incentivized referral pre-launch</a>, we cherry-picked components from both campaigns. We created a one-of-a-kind mash-up for the client&apos;s pre-launch: a viral campaign that pitted dog and cat lovers against each other. Over the course of just ten days, and without spending a dime on advertising, the landing page saw 130,000+ unique visitors. We got 40,000 email leads and 50,000+ social likes, shares, and comments. Our campaign was a smashing hit with hundreds of local animal shelters, leading to millions of social media impressions.</p>

            <p>Days after the official launch of the client&apos;s ecommerce site, most of their merchandise sold out due to popular demand.</p>
            <Button label="Our Services" href="/services" light ghost/>
          </div>
          <div className={css.image}>
            <Picture
              base="/images/misc/dogsVsCats/dogsVsCats"
              alt=""
              exts={["webp", "png"]}
              widths={[250, 500]}
              loading="lazy"
              sizes="50vw"
            />
          </div>
        </div>
        <div className={css.caseStudy}>
          <div className={css.text}>
            <h3>
              <div>#1 Viral Song</div>
              <div>in the World</div>
            </h3>

            <p>A freshly formed group of musicians led by a celebrity pop artist hired us to help their budding band land a global tour.</p>

            <p>Our growth marketing ideation phase revealed that the client had just released a 4-track EP. We needed to capture the attention of the music industry&apos;s gatekeepers to validate our client&apos;s world tour aspirations. The primary goal was to top Spotify&apos;s &quot;Viral 50&quot; chart, while supporting a rising tide across YouTube, Apple Music, and other platforms.</p>

            <p>While we can&apos;t disclose the technical details of our methodology, we helped the client top the Viral 50 chart, beating out the likes of Drake and Justin Timberlake. And the campaign&apos;s success eventually landed the client their global tour.</p>

            <Button label="Our Services" href="/services" light ghost/>
          </div>
          <div className={css.image}>
            <Picture
              base="/images/misc/topFiftySpotify/topFiftySpotify"
              alt=""
              exts={["webp", "png"]}
              widths={[250, 500]}
              loading="lazy"
              sizes="50vw"
            />
          </div>
        </div>
      </div>
    </section>


    <section className={`section ${css.testimonials}`}>
      <div className="sectionInner">
        <h2>Testimonials</h2>
        <div className={css.subheadline}>We seek to work with passionate and driven entrepreneurs above all else. We are agnostic to the industry (in fact, we relish the opportunity to apply our innovations to new industries). Here is what some of our past clients have to say about working with us...</div>

        <div className={css.cards}>
          {testimonials.map((testimonial) => <div key={testimonial.author} className={css.card}>
            <picture>
              <source srcSet={`${testimonial.image}.webp`} type="image/webp"/>
              <source srcSet={`${testimonial.image}.png`} type="image/png"/>
              <img loading="lazy" src={`${testimonial.image}.png`} alt=""/>
            </picture>
            <div className={css.text}>
              <div className={css.quote}>{testimonial.quote}</div>
              <div className={css.name}>{testimonial.author}</div>
            </div>
          </div>)}
        </div>
      </div>
    </section>


    <ContactSection color="purple"/>

  </GenericLayout>;
}

